import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// ── 1. Disable right-click ───────────────────────────────────────
document.addEventListener('contextmenu', e => e.preventDefault());

// ── 2. Disable text selection ────────────────────────────────────
document.addEventListener('selectstart', e => e.preventDefault());

// ── 3. Block keyboard shortcuts ──────────────────────────────────
document.addEventListener('keydown', e => {
  const key = e.key.toLowerCase();
  // Block: Ctrl+S, Ctrl+A, Ctrl+C, Ctrl+U, Ctrl+P, Ctrl+Shift+I/J/C, F12
  if (
    (e.ctrlKey && ['s','a','c','u','p'].includes(key)) ||
    (e.ctrlKey && e.shiftKey && ['i','j','c'].includes(key)) ||
    e.key === 'F12'
  ) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
});

// ── 4. Disable drag (prevents image saving) ──────────────────────
document.addEventListener('dragstart', e => e.preventDefault());

// ── 5. Disable print ─────────────────────────────────────────────
window.addEventListener('beforeprint', e => e.preventDefault());

// ── 6. DevTools detection ────────────────────────────────────────
const LOCK_SCREEN = `
  <div style="
    display:flex; align-items:center; justify-content:center;
    height:100vh; background:#0A0F1E; flex-direction:column; gap:20px;
    font-family: sans-serif;">
    <div style="font-size:56px">🔒</div>
    <div style="color:#FF4D4D; font-size:20px; font-weight:700;">
      Access Restricted
    </div>
    <div style="color:#8BA3BC; font-size:14px; text-align:center; max-width:320px; line-height:1.7;">
      Developer tools are not permitted on this page.<br/>
      This tool is proprietary to Akrobourn Consultants LLP.
    </div>
  </div>`;

let devtoolsOpen = false;
setInterval(() => {
  const widthDiff  = window.outerWidth  - window.innerWidth  > 160;
  const heightDiff = window.outerHeight - window.innerHeight > 160;
  if ((widthDiff || heightDiff) && !devtoolsOpen) {
    devtoolsOpen = true;
    document.body.innerHTML = LOCK_SCREEN;
  }
  if (!widthDiff && !heightDiff && devtoolsOpen) {
    devtoolsOpen = false;
    window.location.reload();
  }
}, 1000);

// ── 7. CSS protection ────────────────────────────────────────────
const style = document.createElement('style');
style.innerHTML = `
  * {
    -webkit-user-select: none !important;
    -moz-user-select:    none !important;
    -ms-user-select:     none !important;
    user-select:         none !important;
    -webkit-touch-callout: none !important;
  }
  input, textarea {
    -webkit-user-select: text !important;
    user-select: text !important;
  }
`;
document.head.appendChild(style);

// ── 8. Watermark ─────────────────────────────────────────────────
window.addEventListener('load', () => {
  const wm = document.createElement('div');
  wm.innerHTML = '© Akrobourn Consultants LLP — Proprietary Tool';
  wm.style.cssText = `
    position: fixed;
    bottom: 10px;
    right: 16px;
    font-size: 11px;
    color: rgba(139,163,188,0.4);
    font-family: sans-serif;
    pointer-events: none;
    z-index: 9999;
    letter-spacing: 0.05em;
  `;
  document.body.appendChild(wm);
});

// ── Render App ───────────────────────────────────────────────────
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);